<cc-top-bar [title]="'IVR.LABEL'" >
  <a *ngIf="!isFreePlan"
    routerLink="/ivr/add"
    title="{{ 'IVR.ADD_IVR_TITLE' | translate }}">
    <cc-top-bar-item>
      <span>+ </span>
      <span translate>IVR.ADD_IVR_TITLE</span>
    </cc-top-bar-item>
  </a>
</cc-top-bar>
<cc-ivr-not-available *ngIf="isFreePlan"></cc-ivr-not-available>
<router-outlet *ngIf="!isFreePlan"></router-outlet>
